import {getPrimaryAsset} from '@sollapay/domain/asset-types';
import {Card, CardBody, CardHeader, CardHeaderContent} from '@sollapay/ui/components';

import {AssetHeader} from '@/features/buyers/view/components';

import {AssetTrustProgress} from './AssetTrustProgress';
import {BuyerRegulatoryReportsBadge} from './BuyerRegulatoryReportsBadge';

import type {BuyerPurchaseDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface AssetTrustSummaryCardProps {
  purchase: BuyerPurchaseDTO;
  amountToPayNis: string;
  depositPaidNis: string;
  trustAccountId: string;
}

/** General sale caps at one purchase per account, so this card always summarizes exactly one asset. */
export const AssetTrustSummaryCard: FC<AssetTrustSummaryCardProps> = ({
  purchase,
  amountToPayNis,
  depositPaidNis,
  trustAccountId
}) => (
  <Card>
    <CardHeader className="items-center">
      <CardHeaderContent>
        <AssetHeader asset={getPrimaryAsset(purchase)} />
      </CardHeaderContent>
      <BuyerRegulatoryReportsBadge purchase={purchase} trustAccountId={trustAccountId} size="lg" />
    </CardHeader>
    <CardBody>
      <AssetTrustProgress
        purchasePriceNis={purchase.purchasePriceNis}
        amountToPayNis={amountToPayNis}
        depositPaidNis={depositPaidNis}
      />
    </CardBody>
  </Card>
);
